import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Lightbox from './components/Lightbox';

const categories = [
  { name: 'All', slug: 'all' },
  { name: 'Romantic', slug: 'romantic' },
  { name: 'Birthday', slug: 'birthday' },
  { name: 'Anniversary', slug: 'anniversary' },
  { name: 'Just Because', slug: 'just-because' }
];

const galleryImages = [
  {
    url: 'https://public.readdy.ai/ai/img_res/a30d10740204df0f39cb132988639872.jpg',
    category: 'romantic',
    title: 'Romantic Rose Setup',
    description: 'Intimate dinner with roses and candles'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=birthday%20surprise%20decoration%20with%20colorful%20balloons%20confetti%20streamers%20and%20gift%20boxes%20festive%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=800&seq=gal102&orientation=squarish',
    category: 'birthday',
    title: 'Birthday Celebration',
    description: 'Colorful birthday party setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=anniversary%20surprise%20decoration%20with%20gold%20balloons%20champagne%20glasses%20rose%20petals%20and%20elegant%20lighting%20romantic%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal103&orientation=portrait',
    category: 'anniversary',
    title: 'Anniversary Elegance',
    description: 'Golden anniversary celebration'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=intimate%20surprise%20decoration%20with%20fairy%20lights%20flowers%20and%20cozy%20cushions%20romantic%20evening%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal104&orientation=portrait',
    category: 'just-because',
    title: 'Cozy Evening',
    description: 'Intimate surprise setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=proposal%20surprise%20decoration%20with%20marry%20me%20letters%20rose%20petals%20candles%20and%20romantic%20lighting%20elegant%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=800&seq=gal105&orientation=squarish',
    category: 'romantic',
    title: 'Marriage Proposal',
    description: 'Unforgettable proposal moment'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=celebration%20surprise%20decoration%20with%20pastel%20balloons%20flowers%20and%20elegant%20table%20setting%20soft%20lighting%20festive%20atmosphere%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal106&orientation=portrait',
    category: 'birthday',
    title: 'Pastel Birthday',
    description: 'Elegant birthday celebration'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=romantic%20dinner%20surprise%20decoration%20with%20candles%20rose%20petals%20and%20elegant%20table%20setting%20warm%20lighting%20intimate%20atmosphere%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal107&orientation=portrait',
    category: 'anniversary',
    title: 'Romantic Dinner',
    description: 'Candlelit anniversary dinner'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=surprise%20decoration%20with%20balloons%20flowers%20and%20gift%20boxes%20colorful%20festive%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=800&seq=gal108&orientation=squarish',
    category: 'just-because',
    title: 'Surprise Celebration',
    description: 'Just because moments'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=elegant%20surprise%20decoration%20with%20white%20balloons%20roses%20and%20candles%20romantic%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal109&orientation=portrait',
    category: 'romantic',
    title: 'White Elegance',
    description: 'Pure romantic setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=birthday%20party%20surprise%20decoration%20with%20colorful%20balloons%20cake%20and%20festive%20elements%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal110&orientation=portrait',
    category: 'birthday',
    title: 'Birthday Party',
    description: 'Festive birthday setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=romantic%20picnic%20surprise%20decoration%20with%20flowers%20blanket%20cushions%20and%20fairy%20lights%20outdoor%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=800&seq=gal111&orientation=squarish',
    category: 'romantic',
    title: 'Romantic Picnic',
    description: 'Outdoor romantic setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=anniversary%20celebration%20decoration%20with%20silver%20balloons%20champagne%20and%20roses%20elegant%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal112&orientation=portrait',
    category: 'anniversary',
    title: 'Silver Anniversary',
    description: 'Elegant milestone celebration'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=surprise%20decoration%20with%20pink%20balloons%20flowers%20and%20sweet%20treats%20festive%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal113&orientation=portrait',
    category: 'just-because',
    title: 'Sweet Surprise',
    description: 'Thoughtful gesture setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=birthday%20surprise%20decoration%20with%20rainbow%20balloons%20confetti%20and%20party%20decorations%20colorful%20celebration%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=800&seq=gal114&orientation=squarish',
    category: 'birthday',
    title: 'Rainbow Birthday',
    description: 'Vibrant birthday celebration'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=romantic%20bedroom%20surprise%20decoration%20with%20rose%20petals%20candles%20and%20fairy%20lights%20intimate%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal115&orientation=portrait',
    category: 'romantic',
    title: 'Bedroom Romance',
    description: 'Intimate bedroom setup'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=anniversary%20dinner%20decoration%20with%20elegant%20table%20setting%20candles%20and%20flowers%20romantic%20setup%20professional%20photography%20simple%20clean%20background&width=800&height=1000&seq=gal116&orientation=portrait',
    category: 'anniversary',
    title: 'Anniversary Dinner',
    description: 'Elegant dining experience'
  }
];

export default function GalleryPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const filteredImages = activeCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  const openLightbox = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-cream via-white to-pink/10 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-20 left-10 w-32 h-32 bg-coral rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 bg-pink rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <span className="text-coral text-sm font-medium">/gallery</span>
            <h1 className="font-serif font-black text-5xl md:text-7xl text-charcoal mt-4 mb-6">
              Moments We've<br />Brought to Life
            </h1>
            <p className="text-charcoal/70 text-lg max-w-2xl mx-auto">
              Explore our collection of <strong>intimate moments</strong>, <strong>romantic proposals</strong>, and <strong>celebrations</strong> we've created for our clients
            </p>
          </motion.div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-white sticky top-20 z-40 border-b border-charcoal/10">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <motion.button
                key={category.slug}
                onClick={() => setActiveCategory(category.slug)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`px-6 py-2.5 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.slug
                    ? 'bg-coral text-white shadow-lg'
                    : 'bg-cream text-charcoal hover:bg-coral/10'
                }`}
              >
                {category.name}
              </motion.button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div 
            layout
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
          >
            {filteredImages.map((image, index) => (
              <motion.div
                key={image.url}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.3 }}
                whileHover={{ y: -8 }}
                onClick={() => openLightbox(index)}
                className="group relative rounded-2xl overflow-hidden shadow-lg cursor-pointer bg-cream"
                style={{ height: index % 3 === 0 ? '400px' : index % 2 === 0 ? '320px' : '360px' }}
              >
                <div className="w-full h-full">
                  <img
                    src={image.url}
                    alt={image.title}
                    title={image.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-white font-semibold text-lg mb-1">{image.title}</h3>
                    <p className="text-white/80 text-sm">{image.description}</p>
                  </div>
                  
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                    <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                      <i className="ri-search-line text-white text-2xl"></i>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {filteredImages.length === 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-20"
            >
              <i className="ri-image-line text-6xl text-charcoal/20 mb-4"></i>
              <p className="text-charcoal/60 text-lg">No images found in this category</p>
            </motion.div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-coral to-pink relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-20 w-40 h-40 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-20 w-40 h-40 bg-white rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif font-black text-4xl md:text-5xl text-white mb-6">
              Ready to Create Your<br />Perfect Moment?
            </h2>
            <p className="text-white/90 text-lg mb-8">
              Let us bring your vision to life with our expert decoration services
            </p>
            <a
              href="/#contact"
              className="inline-block bg-white text-coral px-8 py-4 rounded-full font-semibold hover:bg-cream transition-colors cursor-pointer whitespace-nowrap"
            >
              Book Your Surprise <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />

      {/* Lightbox */}
      {lightboxOpen && (
        <Lightbox
          images={filteredImages}
          currentIndex={currentImageIndex}
          onClose={() => setLightboxOpen(false)}
          onNavigate={setCurrentImageIndex}
        />
      )}
    </div>
  );
}
